'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'delete-left';
var width = 576;
var height = 512;
var aliases = [9003,"backspace"];
var unicode = 'f55a';
var svgPathData = 'M512 64H205.3C188.3 64 172 70.75 160 82.75L9.375 233.4c-12.5 12.5-12.5 32.75 0 45.25L160 429.3C172 441.3 188.3 448 205.3 448H512c35.38 0 64-28.62 64-64V128C576 92.63 547.4 64 512 64zM544 384c0 17.64-14.36 32-32 32H205.3c-8.541 0-16.57-3.33-22.62-9.379L32 256l150.6-150.6C188.7 99.33 196.7 96 205.3 96H512c17.64 0 32 14.36 32 32V384zM427.3 180.7c-6.25-6.25-16.38-6.25-22.62 0L352 233.4l-52.69-52.69c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L329.4 256L276.7 308.7c-6.25 6.25-6.25 16.38 0 22.62c6.246 6.246 16.37 6.254 22.62 0L352 278.6l52.69 52.69c6.246 6.246 16.37 6.254 22.62 0c6.25-6.25 6.25-16.38 0-22.62L374.6 256l52.69-52.69C433.6 197.1 433.6 186.9 427.3 180.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeleteLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faDeleteLeft.js
// module id = eFOP
// module chunks = 0